<template>
  <div class="bggray">
    <div class="con100">
      <app-header />
      <div class="wrapper">
        <div class="mod">
          <h1 class="title">
            发票详情
            <span>（温馨提示：修改发票内容或改开增值税专用发票可联系客服021-20219999）</span>
          </h1>
        </div>
        <div class="mod">
          <table class="table table-aleft" width="100%" cellpadding="0" cellspacing="0">
            <tr>
              <th colspan="2">
                发票信息
                <span>订单号：{{orderId}}</span>
              </th>
            </tr>
            <tr>
              <td width="180">发票类型</td>
              <td>电子普通发票</td>
            </tr>
            <tr>
              <td>发票内容</td>
              <td>信息技术服务</td>
            </tr>
            <tr>
              <td>发票抬头</td>
              <td v-if="invoiceInfo.invoiceTitleType == 1">个人</td>
              <td v-if="invoiceInfo.invoiceTitleType == 2">单位</td>
            </tr>
          </table>
          <table class="table table-acenter" width="100%" cellpadding="0" cellspacing="0">
            <tr>
              <th width="33%">发票代码</th>
              <th width="34%">发票号码</th>
              <th>下载电子普通发票</th>
            </tr>
            <tr v-for="(item, index) in invoiceInfo" :key="index">
              <td>{{item.invoiceCode}}</td>
              <td>{{item.invoiceNo}}</td>
              <td>
                <a href="#" @click="invoiceDownload(item)">下载电子普通发票</a>
              </td>
            </tr>
          </table>
          <router-link class="btn-normal" to="/personal/orderlist">返 回</router-link>
        </div>
      </div>
    </div>
    <div class="con100-footer">
      <app-footer />
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
export default {
  data() {
    return {
      orderId: this.$route.params.orderId,
      invoiceInfo: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/invoice/query?orderId=" + this.orderId)
        .then(response => {
          if (response.code === 0) {
            this.invoiceInfo = response.data;
          } else if (response.code != 100) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    invoiceDownload(invoiceInfo) {
      var params = {
        invoiceCode: invoiceInfo.invoiceCode,
        invoiceNo: invoiceInfo.invoiceNo
      };
      this.$get("/invoice/querypdf", params)
        .then(response => {
          if (response.code === 0) {
            window.open(response.data, "_blank");
          } else {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    }
  },
  components: {
    AppHeader,
    AppFooter
  }
};
</script>

<style scoped>
.wrapper {
  padding: 20px 0 180px;
  width: 977px;
  margin: 0 auto;
  position: relative;
}
.mod {
  background: #fff;
  padding: 10px 20px;
  color: #222;
  margin-bottom: 10px;
}
.mod h1 {
  line-height: 32px;
  font-size: 14px;
  font-weight: bold;
}
.mod h1 span {
  color: #999;
  font-weight: normal;
  font-size: 12px;
  margin-left: 15px;
}
.table {
  margin: 10px auto 20px;
  border-collapse: collapse;
}
.table tr th {
  height: 34px;
  background: #f5f5f5;
  padding: 0 18px;
  font-size: 14px;
  color: #222;
}
.table tr td {
  height: 38px;
  font-size: 12px;
  color: #666;
  border: 1px solid #f5f5f5;
}
.table tr th span {
  margin-left: 10px;
}
.table tr td a {
  color: #238efa;
}
.table-aleft tr td {
  padding-left: 20px;
}
.table-acenter tr td {
  height: 86px;
  text-align: center;
}
.wrapper .btn-normal {
  right: 0;
  bottom: 75px;
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/InvoiceDetail.vue